var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "re-charge-box" }, [
      _c("div", { staticClass: "banks" }, [
        _c(
          "div",
          {
            staticClass: "bank-item text-center",
            class: { active: _vm.bankSelected.id === 2 },
            on: {
              click: function($event) {
                return _vm.onSelectBank(2)
              }
            }
          },
          [
            _c("img", {
              attrs: { src: "img/icons/vietinbank-logo.png", alt: "vietinbank" }
            })
          ]
        ),
        _c(
          "div",
          {
            staticClass: "bank-item",
            class: { active: _vm.bankSelected.id === 1 },
            on: {
              click: function($event) {
                return _vm.onSelectBank(1)
              }
            }
          },
          [
            _c("img", {
              attrs: { src: "img/icons/mbbank-logo.png", alt: "mbbank" }
            })
          ]
        )
      ]),
      _c("div", { staticClass: "bank-info" }, [
        _c("div", { staticClass: "guide-transfer" }, [
          _c("img", {
            staticStyle: { width: "480px" },
            attrs: { src: _vm.qrLink }
          })
        ])
      ]),
      _vm.showGuide === 1
        ? _c("div", { staticClass: "guide-transfer" }, [
            _c("span", { staticClass: "fb hpo-b" }, [
              _vm._v(
                "Quý khách quét mã QR để chuyển khoản, tiền sẽ tự động được cộng vào ví (f5 lại trang để xem cập nhật). Nếu sau 5p số dư ví không được cập nhật, vui lòng liên hệ CSKH để được hỗ trợ. "
              )
            ])
          ])
        : _vm._e(),
      _vm.showGuide === 1
        ? _c("div", { staticClass: "guide-transfer" }, [
            _c("span", { staticClass: "fb hpo" }, [
              _vm._v(
                "LƯU Ý: nội dung chuyển khoản được hệ thống tạo sẵn, để tránh sai sót, quý khách vui lòng KHÔNG thay đổi nội dung chuyển khoản."
              )
            ])
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }